import React, { useState } from 'react';

interface ContactFormProps {
  onSubmit: (formData: { name: string; email: string; phone?: string }) => void;
  onClose?: () => void;
}

export function ContactForm({ onSubmit, onClose }: ContactFormProps) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="mx-auto w-[90%] bg-white/80 rounded-xl backdrop-blur-sm shadow-[0_0_15px_rgba(254,240,198,0.3)] border border-valeYellow/30 p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-800">Contact Information</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
            Name *
          </label>
          <input
            type="text"
            id="name"
            required
            className="mt-1 block w-full rounded-xl border-gray-300 shadow-sm focus:border-valeYellow focus:ring-valeYellow bg-white/50 px-3 py-2"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="Enter your name"
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
            Email *
          </label>
          <input
            type="email"
            id="email"
            required
            className="mt-1 block w-full rounded-xl border-gray-300 shadow-sm focus:border-valeYellow focus:ring-valeYellow bg-white/50 px-3 py-2"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="Enter your email"
          />
        </div>
        <div>
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
            Phone (optional)
          </label>
          <input
            type="tel"
            id="phone"
            className="mt-1 block w-full rounded-xl border-gray-300 shadow-sm focus:border-valeYellow focus:ring-valeYellow bg-white/50 px-3 py-2"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            placeholder="Enter your phone number"
          />
        </div>
        <div className="flex justify-end space-x-2 pt-4">
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors duration-200"
            >
              Cancel
            </button>
          )}
          <button
            type="submit"
            className="px-4 py-2 text-sm font-medium text-white bg-valeYellow rounded-xl hover:bg-valeYellow/90 transition-colors duration-200"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}